import SmallDetails from "components/SmallDetails/SmallDetails";
import OptionalNumberInput from "components/ValidatedFields/OptionalNumberInput";
import moment from "moment";
import React from "react";
import { formatTimeDifference } from "utilities";

interface Props {
  value: number
  googleEstimatedDurationMinutes?: number
  onChange: (newValue: number) => void
  autoFocus?: boolean
  onEnter?: (newValue: number) => void
  onEsc?: () => void
}

export const GroundTransportDurationInput = (props: Props) => {
  const durationEstimateGoogleLabel = props.googleEstimatedDurationMinutes
    ? ` ${RESX.DateTime.XMinutes.replace("{0}", props.googleEstimatedDurationMinutes.toString())} ${RESX.GroundTransport.AccordingToGoogle}`
    : null;
  const durationEstimateGoogleFormatted = props.googleEstimatedDurationMinutes
    ? formatTimeDifference(moment.utc(), moment.utc().add(props.googleEstimatedDurationMinutes, "minute"))
    : null;

  return <div className="flex gap-small">
    <OptionalNumberInput
      width={50}
      canBeNegative={false}
      labelContent={RESX.DateTime.Minutes}
      decimalPoints={0}
      maxLength={4}
      value={props.value}
      onChange={props.onChange}
      onEnterPressed={props.onEnter}
      onEscPressed={props.onEsc}
      autoFocus={props.autoFocus}
    />
    {(props.googleEstimatedDurationMinutes !== 0) && <SmallDetails
      label={durationEstimateGoogleLabel}
      subLabel={durationEstimateGoogleFormatted}
    />}
  </div>
}